import { render, staticRenderFns } from "./parkdriverv1.vue?vue&type=template&id=edd206a8&scoped=true&"
import script from "./parkdriverv1.vue?vue&type=script&lang=js&"
export * from "./parkdriverv1.vue?vue&type=script&lang=js&"
import style0 from "./parkdriverv1.vue?vue&type=style&index=0&id=edd206a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edd206a8",
  null
  
)

export default component.exports